/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
export const gmaoInputEmailComponent = {
    template: require('./gmao-input-email.html'),
    bindings: {
        model: '=',
        modelOptions: '<',
        validationError: '<',
        disabled: '<',
        readonly: '<',
        required: '<',
        placeholderKey: '<',
        hintKey: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/component/GmaoInputEmail.js